module.exports = __webpack_public_path__ + "img/zhangjiakou.2096a70d.png";